import { heroImage } from '../data/copy'

const TITLE =
  'The Pickleball Instructor’s Vault™ — 150 Ready-to-Teach Lessons & Drills'

const DESCRIPTION =
  'Solve a full year of professional pickleball coaching in 5 minutes. 6 volumes, 150 ready-to-teach lessons, 150+ elite drills and 7 strategic bonuses. Instant digital access.'

function setMeta(name: string, content: string): void {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

function setProperty(property: string, content: string): void {
  let tag = document.querySelector<HTMLMetaElement>(
    `meta[property="${property}"]`,
  )
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('property', property)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

/**
 * Sets the document metadata and preloads the LCP image.
 *
 * No fonts and no extra connections: typography is the system stack, so the
 * only thing this needs to prioritise is the hero mockup.
 */
export function setupHead(): void {
  if (typeof document === 'undefined') return

  document.documentElement.lang = 'en'
  document.title = TITLE

  setMeta('description', DESCRIPTION)
  setMeta('theme-color', '#08152B')
  setMeta('viewport', 'width=device-width, initial-scale=1, viewport-fit=cover')

  setProperty('og:type', 'website')
  setProperty('og:title', TITLE)
  setProperty('og:description', DESCRIPTION)
  setProperty('og:image', heroImage)

  // Preload the LCP image so it downloads before React even mounts.
  const preload = document.createElement('link')
  preload.rel = 'preload'
  preload.as = 'image'
  preload.href = heroImage
  preload.setAttribute('fetchpriority', 'high')
  document.head.appendChild(preload)
}
